// import React, { useState, useEffect } from "react";
// import { Modal, Button, Alert, Spinner, Form } from "react-bootstrap";
// import { toast } from "react-toastify";
// import { getDatabase, ref, get, set, push, child } from "firebase/database";
// import { app } from "../../../Doctor/Firebase/firebase.config";
// import { useAuth } from "../../AuthContext";
// import emailjs from "@emailjs/browser";

// const database = getDatabase(app);

// // ==================== EMAILJS CONFIGURATION ====================
// const EMAILJS_SERVICE_ID = 'service_cab38e6';
// const EMAILJS_OTP_TEMPLATE_ID = 'template_h08g4fm';
// const EMAILJS_CONFIRMATION_TEMPLATE_ID = 'template_c2m3r4j';
// const EMAILJS_PUBLIC_KEY = 'rnBYIQUEQDDpqOcl1';

// // ==================== STYLES ====================
// const styles = {
//   modalContent: {
//     borderRadius: '16px',
//     border: 'none',
//     boxShadow: '0 10px 40px rgba(0, 0, 0, 0.1)',
//     overflow: 'hidden'
//   },
//   modalHeader: {
//     background: 'linear-gradient(135deg, #4285f4 0%, #34a853 100%)',
//     color: 'white',
//     padding: '20px 30px',
//     borderBottom: 'none'
//   },
//   doctorInfo: {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '15px'
//   },
//   doctorAvatar: {
//     width: '60px',
//     height: '60px',
//     borderRadius: '50%',
//     backgroundColor: 'white',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     fontSize: '24px',
//     fontWeight: 'bold',
//     color: '#4285f4'
//   },
//   doctorDetails: {
//     flex: 1
//   },
//   doctorName: {
//     fontSize: '20px',
//     fontWeight: '600',
//     margin: 0,
//     color: 'white'
//   },
//   doctorSpeciality: {
//     fontSize: '14px',
//     opacity: 0.9,
//     margin: 0,
//     color: 'white'
//   },
//   modalBody: {
//     padding: '30px',
//     backgroundColor: '#f8f9fa',
//     minHeight: '500px'
//   },
//   progressBar: {
//     display: 'flex',
//     justifyContent: 'space-between',
//     marginBottom: '30px',
//     position: 'relative',
//     backgroundColor: 'white',
//     padding: '20px',
//     borderRadius: '12px',
//     boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)'
//   },
//   progressStep: {
//     flex: 1,
//     textAlign: 'center',
//     position: 'relative',
//     zIndex: 2
//   },
//   progressCircle: {
//     width: '40px',
//     height: '40px',
//     borderRadius: '50%',
//     backgroundColor: '#e0e0e0',
//     color: '#666',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     margin: '0 auto 8px',
//     fontWeight: 'bold',
//     fontSize: '16px',
//     transition: 'all 0.3s ease'
//   },
//   progressCircleActive: {
//     backgroundColor: '#4285f4',
//     color: 'white',
//     boxShadow: '0 4px 12px rgba(66, 133, 244, 0.4)'
//   },
//   progressCircleCompleted: {
//     backgroundColor: '#34a853',
//     color: 'white'
//   },
//   progressLabel: {
//     fontSize: '12px',
//     color: '#666',
//     fontWeight: '500'
//   },
//   progressLabelActive: {
//     color: '#4285f4',
//     fontWeight: '600'
//   },
//   stepContainer: {
//     backgroundColor: 'white',
//     padding: '30px',
//     borderRadius: '12px',
//     boxShadow: '0 2px 12px rgba(0, 0, 0, 0.06)',
//     minHeight: '400px'
//   },
//   stepTitle: {
//     fontSize: '22px',
//     fontWeight: '700',
//     color: '#333',
//     marginBottom: '25px',
//     paddingBottom: '15px',
//     borderBottom: '3px solid #4285f4'
//   },
//   sessionTitle: {
//     backgroundColor: '#f1f3f4',
//     padding: '12px 20px',
//     borderRadius: '8px',
//     fontWeight: '600',
//     color: '#333',
//     marginBottom: '15px',
//     marginTop: '20px'
//   },
//   breakTitle: {
//     backgroundColor: '#fff3cd',
//     padding: '12px 20px',
//     borderRadius: '8px',
//     fontWeight: '600',
//     color: '#856404',
//     marginBottom: '15px',
//     marginTop: '20px',
//     textAlign: 'center',
//     border: '1px solid #ffeaa7'
//   },
//   slotsGrid: {
//     display: 'grid',
//     gridTemplateColumns: 'repeat(auto-fill, minmax(110px, 1fr))',
//     gap: '10px',
//     marginBottom: '20px'
//   },
//   slotButton: {
//     padding: '10px',
//     borderRadius: '8px',
//     border: '2px solid #e0e0e0',
//     backgroundColor: 'white',
//     fontSize: '13px',
//     fontWeight: '500',
//     cursor: 'pointer',
//     transition: 'all 0.2s ease',
//     textAlign: 'center'
//   },
//   slotButtonSelected: {
//     backgroundColor: '#4285f4',
//     color: 'white',
//     border: '2px solid #4285f4',
//     fontWeight: '600'
//   },
//   slotButtonBooked: {
//     backgroundColor: '#f5f5f5',
//     color: '#999',
//     border: '2px solid #e0e0e0',
//     cursor: 'not-allowed',
//     textDecoration: 'line-through'
//   },
//   otpContainer: {
//     textAlign: 'center',
//     padding: '40px 20px'
//   },
//   otpInputs: {
//     display: 'flex',
//     justifyContent: 'center',
//     gap: '15px',
//     marginTop: '30px',
//     marginBottom: '30px'
//   },
//   otpInput: {
//     width: '55px',
//     height: '55px',
//     fontSize: '24px',
//     fontWeight: 'bold',
//     textAlign: 'center',
//     border: '2px solid #e0e0e0',
//     borderRadius: '12px',
//     transition: 'all 0.3s ease'
//   },
//   formGroup: {
//     marginBottom: '20px'
//   },
//   formLabel: {
//     fontSize: '14px',
//     fontWeight: '600',
//     color: '#333',
//     marginBottom: '8px',
//     display: 'block'
//   },
//   formInput: {
//     width: '100%',
//     padding: '12px 15px',
//     fontSize: '15px',
//     border: '2px solid #e0e0e0',
//     borderRadius: '8px',
//     transition: 'all 0.3s ease'
//   },
//   textArea: {
//     width: '100%',
//     padding: '12px 15px',
//     fontSize: '14px',
//     border: '2px solid #e0e0e0',
//     borderRadius: '8px',
//     minHeight: '120px',
//     fontFamily: 'inherit',
//     resize: 'vertical'
//   },
//   summaryCard: {
//     backgroundColor: 'white',
//     borderRadius: '12px',
//     overflow: 'hidden',
//     border: '1px solid #e0e0e0'
//   },
//   summarySection: {
//     padding: '20px',
//     borderBottom: '1px solid #f0f0f0'
//   },
//   summaryTitle: {
//     fontSize: '16px',
//     fontWeight: '700',
//     color: '#333',
//     marginBottom: '15px',
//     display: 'flex',
//     alignItems: 'center',
//     gap: '8px'
//   },
//   summaryRow: {
//     display: 'flex',
//     justifyContent: 'space-between',
//     padding: '10px 0',
//     borderBottom: '1px solid #f8f9fa'
//   },
//   summaryLabel: {
//     fontSize: '14px',
//     color: '#666',
//     fontWeight: '500'
//   },
//   summaryValue: {
//     fontSize: '14px',
//     color: '#333',
//     fontWeight: '600',
//     textAlign: 'right'
//   },
//   highlightBox: {
//     backgroundColor: '#e8f0fe',
//     padding: '15px',
//     borderRadius: '8px',
//     marginBottom: '15px',
//     border: '1px solid #4285f4'
//   },
//   healthDetailsBox: {
//     backgroundColor: '#fff3e0',
//     padding: '15px',
//     borderRadius: '8px',
//     marginTop: '15px',
//     border: '1px solid #ff9800'
//   },
//   btnPrimary: {
//     backgroundColor: '#4285f4',
//     border: 'none',
//     padding: '12px 30px',
//     fontSize: '15px',
//     fontWeight: '600',
//     borderRadius: '8px',
//     transition: 'all 0.3s ease'
//   },
//   btnSuccess: {
//     backgroundColor: '#34a853',
//     border: 'none',
//     padding: '12px 30px',
//     fontSize: '15px',
//     fontWeight: '600',
//     borderRadius: '8px'
//   }
// };

// // Generate time slots with 15-minute intervals
// const generateTimeSlots = (startTime, endTime) => {
//   const slots = [];
  
//   const parseTime = (timeStr) => {
//     const [hours, minutes] = timeStr.split(':').map(Number);
//     const date = new Date();
//     date.setHours(hours, minutes || 0, 0, 0);
//     return date;
//   };
  
//   const start = parseTime(startTime);
//   const end = parseTime(endTime);
  
//   if (end <= start) {
//     console.error("End time must be after start time:", startTime, endTime);
//     return slots;
//   }
  
//   const current = new Date(start);
  
//   while (current < end) {
//     const hours = current.getHours();
//     const minutes = current.getMinutes();
//     const ampm = hours >= 12 ? 'PM' : 'AM';
//     const displayHours = hours % 12 || 12;
//     const displayMinutes = minutes < 10 ? '0' + minutes : minutes;
    
//     slots.push({
//       display: `${displayHours}:${displayMinutes} ${ampm}`,
//       value: `${displayHours}:${displayMinutes} ${ampm}`,
//       time24: `${hours.toString().padStart(2, '0')}:${displayMinutes}`
//     });
    
//     current.setTime(current.getTime() + 15 * 60000);
//   }
  
//   return slots;
// };

// // Check if there should be a break between morning and evening
// const calculateBreakNeeded = (morningEndTime, eveningStartTime) => {
//   const parseTime = (timeStr) => {
//     const [hours, minutes] = timeStr.split(':').map(Number);
//     const date = new Date();
//     date.setHours(hours, minutes || 0, 0, 0);
//     return date;
//   };
  
//   if (!morningEndTime || !eveningStartTime) return false;
  
//   const morningEnd = parseTime(morningEndTime);
//   const eveningStart = parseTime(eveningStartTime);
  
//   const timeDiff = (eveningStart - morningEnd) / (1000 * 60);
  
//   return timeDiff >= 30;
// };

// const TimeSlotModal = ({ show, handleClose, bookingData, onBack, onBookingComplete }) => {
//   const { user } = useAuth();
  
//   const [step, setStep] = useState(1);
//   const [loading, setLoading] = useState(false);
//   const [loadingSlots, setLoadingSlots] = useState(false);
//   const [otpSent, setOtpSent] = useState(false);
//   const [generatedOTP, setGeneratedOTP] = useState('');
  
//   // Step 1: Time Selection
//   const [selectedSlot, setSelectedSlot] = useState('');
//   const [allMorningSlots, setAllMorningSlots] = useState([]);
//   const [allEveningSlots, setAllEveningSlots] = useState([]);
//   const [bookedSlots, setBookedSlots] = useState([]);
//   const [showBreak, setShowBreak] = useState(false);
  
//   // Step 2: OTP Verification
//   const [phoneNumber, setPhoneNumber] = useState('');
//   const [email, setEmail] = useState('');
//   const [otp, setOtp] = useState(['', '', '', '', '', '']);
//   const [phoneError, setPhoneError] = useState('');
//   const [emailError, setEmailError] = useState('');
  
//   // Step 3: Patient Details
//   const [patientName, setPatientName] = useState('');
//   const [nameError, setNameError] = useState('');
//   const [healthIssues, setHealthIssues] = useState('');
//   const [medicalHistory, setMedicalHistory] = useState('');
//   const [currentMedications, setCurrentMedications] = useState('');

//   // Load time slots when modal opens
//   useEffect(() => {
//     if (!show || !bookingData) return;

//     const fetchBookedSlots = async () => {
//       try {
//         setLoadingSlots(true);
        
//         const appointmentsRef = ref(database, `doctor/${bookingData.doctor.uid}/appointments`);
//         const appointmentsSnapshot = await get(appointmentsRef);
        
//         if (appointmentsSnapshot.exists()) {
//           const appointmentsData = appointmentsSnapshot.val();
//           console.log("Booked appointments:", appointmentsData);
//           setBookedSlots(Object.values(appointmentsData));
//         } else {
//           console.log("No booked appointments found");
//           setBookedSlots([]);
//         }
//       } catch (error) {
//         console.error("Error fetching appointments:", error);
//         toast.error("Failed to load appointments");
//       } finally {
//         setLoadingSlots(false);
//       }
//     };

//     fetchBookedSlots();
//   }, [show, bookingData]);

//   // Generate slots when modal opens or when booked slots change
//   useEffect(() => {
//     if (!bookingData || !bookingData.schedule) {
//       setAllMorningSlots([]);
//       setAllEveningSlots([]);
//       setShowBreak(false);
//       return;
//     }

//     console.log("Booking data:", bookingData);
//     console.log("Doctor schedule:", bookingData.schedule);
    
//     let morning = [];
//     if (bookingData.schedule.morningStartTime && bookingData.schedule.morningEndTime) {
//       console.log(`Generating morning slots: ${bookingData.schedule.morningStartTime} to ${bookingData.schedule.morningEndTime}`);
//       morning = generateTimeSlots(
//         bookingData.schedule.morningStartTime,
//         bookingData.schedule.morningEndTime
//       );
//       console.log("Morning slots generated:", morning.length);
//     }

//     let evening = [];
//     if (bookingData.schedule.eveningStartTime && bookingData.schedule.eveningEndTime) {
//       console.log(`Generating evening slots: ${bookingData.schedule.eveningStartTime} to ${bookingData.schedule.eveningEndTime}`);
//       evening = generateTimeSlots(
//         bookingData.schedule.eveningStartTime,
//         bookingData.schedule.eveningEndTime
//       );
//       console.log("Evening slots generated:", evening.length);
//     }

//     const hasBreak = calculateBreakNeeded(
//       bookingData.schedule.morningEndTime,
//       bookingData.schedule.eveningStartTime
//     );
//     setShowBreak(hasBreak);

//     const formattedDate = bookingData.date.toLocaleDateString('en-US', {
//       year: 'numeric',
//       month: '2-digit',
//       day: '2-digit'
//     });
    
//     console.log("Formatted date for booking check:", formattedDate);
    
//     const markBookedSlots = (slots) => {
//       return slots.map(slot => {
//         const isBooked = bookedSlots.some(booking => {
//           const bookingDate = new Date(booking.date).toLocaleDateString('en-US', {
//             year: 'numeric',
//             month: '2-digit',
//             day: '2-digit'
//           });
//           return bookingDate === formattedDate && booking.timeSlot === slot.value;
//         });
//         return { ...slot, isBooked };
//       });
//     };

//     setAllMorningSlots(markBookedSlots(morning));
//     setAllEveningSlots(markBookedSlots(evening));

//     console.log("Total morning slots:", morning.length);
//     console.log("Total evening slots:", evening.length);
//     console.log("Show break:", hasBreak);

//   }, [bookingData, bookedSlots]);

//   // Send OTP
//   const sendOTP = async () => {
//     setPhoneError('');
//     setEmailError('');

//     if (!phoneNumber.trim()) {
//       setPhoneError('Phone number is required');
//       return;
//     }
//     if (!/^[6-9]\d{9}$/.test(phoneNumber)) {
//       setPhoneError('Enter valid 10-digit mobile number');
//       return;
//     }
//     if (!email.trim()) {
//       setEmailError('Email is required');
//       return;
//     }
//     if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
//       setEmailError('Enter valid email address');
//       return;
//     }

//     setLoading(true);
    
//     const otp = Math.floor(100000 + Math.random() * 900000).toString();
//     setGeneratedOTP(otp);
//     console.log("Generated OTP (for testing):", otp);

//     try {
//       const expiryTime = new Date();
//       expiryTime.setMinutes(expiryTime.getMinutes() + 15);
//       const expiryTimeStr = expiryTime.toLocaleTimeString('en-US', { 
//         hour: '2-digit', 
//         minute: '2-digit',
//         hour12: true 
//       });

//       const otpMessage = `Your OTP is: ${otp}\n\nThis OTP will be valid until ${expiryTimeStr}`;
      
//       const emailParams = {
//         to_email: email,
//         to_name: patientName || 'Patient',
//         message: otpMessage,
//         passcode: otp,
//         time: expiryTimeStr,
//         otp: otp,
//         otp_code: otp,
//         OTP: otp,
//         PASSCODE: otp,
//         expiry_time: expiryTimeStr,
//         valid_until: expiryTimeStr,
//         phone_number: phoneNumber,
//         doctor_name: `Dr. ${bookingData.doctor.First} ${bookingData.doctor.Last}`,
//         appointment_date: bookingData.date ? bookingData.date.toLocaleDateString('en-US', { 
//           weekday: 'long',
//           year: 'numeric',
//           month: 'long',
//           day: 'numeric'
//         }) : '',
//         appointment_time: selectedSlot
//       };

//       console.log('Sending OTP email with params:', emailParams);

//       const response = await emailjs.send(
//         EMAILJS_SERVICE_ID,
//         EMAILJS_OTP_TEMPLATE_ID,
//         emailParams,
//         EMAILJS_PUBLIC_KEY
//       );

//       console.log('EmailJS Response:', response);

//       if (response.status === 200) {
//         setOtpSent(true);
//         toast.success(`OTP sent successfully to ${email}. Please check your inbox.`);
//       } else {
//         throw new Error('Email send failed with status: ' + response.status);
//       }
//     } catch (error) {
//       console.error('Error sending OTP:', error);
//       console.error('Error details:', {
//         message: error.message,
//         text: error.text,
//         status: error.status
//       });
      
//       if (error.text) {
//         toast.error(`Failed to send OTP: ${error.text}`);
//       } else {
//         toast.error('Failed to send OTP. Please check your email address and try again.');
//       }
      
//       toast.info(`Development Mode - OTP: ${otp}`, { autoClose: false });
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Verify OTP
//   const verifyOTP = () => {
//     const enteredOTP = otp.join('');
//     if (enteredOTP === generatedOTP) {
//       toast.success('OTP verified successfully!');
//       setStep(3);
//     } else {
//       toast.error('Invalid OTP. Please try again.');
//     }
//   };

//   // Handle OTP input
//   const handleOtpChange = (index, value) => {
//     if (!/^\d*$/.test(value)) return;
    
//     const newOtp = [...otp];
//     newOtp[index] = value;
//     setOtp(newOtp);

//     if (value && index < 5) {
//       const nextInput = document.getElementById(`otp-${index + 1}`);
//       if (nextInput) nextInput.focus();
//     }
//   };

//   // Handle OTP backspace
//   const handleOtpKeyDown = (index, e) => {
//     if (e.key === 'Backspace' && !otp[index] && index > 0) {
//       const prevInput = document.getElementById(`otp-${index - 1}`);
//       if (prevInput) prevInput.focus();
//     }
//   };

//   // Confirm patient details
//   const confirmBooking = async () => {
//     setNameError('');

//     if (!patientName.trim()) {
//       setNameError('Name is required');
//       return;
//     }

//     setStep(4);
//   };

//   // Final booking
//   const finalizeBooking = async () => {
//     if (!user || !user.userId) {
//       toast.error('Please login to book appointment');
//       return;
//     }

//     setLoading(true);

//     try {
//       const appointmentData = {
//         patientID: user.userId,
//         date: bookingData.date.toLocaleDateString('en-US', {
//           year: 'numeric',
//           month: '2-digit',
//           day: '2-digit'
//         }),
//         timeSlot: selectedSlot,
//         patientName: patientName,
//         patientPhone: phoneNumber,
//         patientEmail: email,
//         healthIssues: healthIssues,
//         medicalHistory: medicalHistory,
//         currentMedications: currentMedications,
//         status: 'Confirmed',
//         bookingDate: new Date().toISOString(),
//         doctorId: bookingData.doctor.uid,
//         doctorName: `Dr. ${bookingData.doctor.First} ${bookingData.doctor.Last}`,
//         speciality: bookingData.doctor.Speciality
//       };

//       const appointmentRef = ref(database, `doctor/${bookingData.doctor.uid}/appointments`);
//       const appointmentKey = push(appointmentRef).key;
      
//       await set(child(appointmentRef, appointmentKey), appointmentData);

//       const userAppointmentRef = ref(database, `users/${user.userId}/appointments/${appointmentKey}`);
//       await set(userAppointmentRef, {
//         ...appointmentData,
//         appointmentId: appointmentKey
//       });

//       // Send confirmation email
//       try {
//         await emailjs.send(
//           EMAILJS_SERVICE_ID,
//           EMAILJS_CONFIRMATION_TEMPLATE_ID,
//           {
//             Patient_Email: email,
//             Patient_Name: patientName,
//             Doctor_Name: `Dr. ${bookingData.doctor.First} ${bookingData.doctor.Last}`,
//             Apn_Date: bookingData.date.toLocaleDateString(),
//             Apn_Time: selectedSlot,
//             Doctor_Speciality: bookingData.doctor.Speciality,
//             Clinic_Name: bookingData.doctor.ClinicName || "Doctor's Clinic",
//             Appointment_ID: appointmentKey,
//             Booking_Date: new Date().toLocaleDateString()
//           },
//           EMAILJS_PUBLIC_KEY
//         );
//         console.log("Confirmation email sent successfully");
//       } catch (emailError) {
//         console.error("Email send error:", emailError);
//         toast.warning("Appointment booked but confirmation email failed to send.");
//       }

//       toast.success('Appointment booked successfully!');
      
//       // Call onBookingComplete callback
//       if (onBookingComplete) {
//         onBookingComplete();
//       }
      
//       setTimeout(() => handleModalClose(), 2000);
//     } catch (error) {
//       console.error('Error booking:', error);
//       toast.error('Booking failed. Please try again.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleModalClose = () => {
//     setStep(1);
//     setSelectedSlot('');
//     setPhoneNumber('');
//     setEmail('');
//     setOtp(['', '', '', '', '', '']);
//     setPatientName('');
//     setHealthIssues('');
//     setMedicalHistory('');
//     setCurrentMedications('');
//     setOtpSent(false);
//     setShowBreak(false);
//     handleClose();
//   };

//   const formatDate = (date) => {
//     return date.toLocaleDateString('en-US', { 
//       weekday: 'long',
//       month: 'long', 
//       day: 'numeric',
//       year: 'numeric'
//     });
//   };

//   const handleSlotClick = (slot) => {
//     if (slot.isBooked) {
//       toast.warning('This slot is already booked. Please select another slot.');
//       return;
//     }
//     setSelectedSlot(slot.value);
//   };

//   const totalAvailableSlots = allMorningSlots.filter(s => !s.isBooked).length + 
//                                allEveningSlots.filter(s => !s.isBooked).length;

//   return (
//     <Modal show={show} onHide={handleModalClose} size="lg" centered>
//       <div style={styles.modalContent}>
//         <Modal.Header closeButton style={styles.modalHeader}>
//           <div style={styles.doctorInfo}>
//             <div style={styles.doctorAvatar}>
//               {bookingData?.doctor.First?.charAt(0)}{bookingData?.doctor.Last?.charAt(0)}
//             </div>
//             <div style={styles.doctorDetails}>
//               <h4 style={styles.doctorName}>Dr. {bookingData?.doctor.First} {bookingData?.doctor.Last}</h4>
//               <p style={styles.doctorSpeciality}>{bookingData?.doctor.Speciality}</p>
//             </div>
//           </div>
//         </Modal.Header>

//         <Modal.Body style={styles.modalBody}>
//           {/* Progress Bar */}
//           <div style={styles.progressBar}>
//             <div style={styles.progressStep}>
//               <div style={{
//                 ...styles.progressCircle,
//                 ...styles.progressCircleCompleted
//               }}>
//                 ✓
//               </div>
//               <div style={styles.progressLabel}>
//                 Select Date
//               </div>
//             </div>

//             <div style={styles.progressStep}>
//               <div style={{
//                 ...styles.progressCircle,
//                 ...(step >= 1 ? styles.progressCircleActive : {}),
//                 ...(step > 1 ? styles.progressCircleCompleted : {})
//               }}>
//                 {step > 1 ? '✓' : '2'}
//               </div>
//               <div style={{
//                 ...styles.progressLabel,
//                 ...(step === 1 ? styles.progressLabelActive : {})
//               }}>
//                 Select Time
//               </div>
//             </div>

//             <div style={styles.progressStep}>
//               <div style={{
//                 ...styles.progressCircle,
//                 ...(step >= 3 ? styles.progressCircleActive : {}),
//                 ...(step > 3 ? styles.progressCircleCompleted : {})
//               }}>
//                 {step > 3 ? '✓' : '3'}
//               </div>
//               <div style={{
//                 ...styles.progressLabel,
//                 ...(step === 3 ? styles.progressLabelActive : {})
//               }}>
//                 Verify & Book
//               </div>
//             </div>
//           </div>

//           {/* Step 1: Select Time */}
//           {step === 1 && (
//             <div style={styles.stepContainer}>
//               <h5 style={styles.stepTitle}>
//                 Select Time Slot
//               </h5>

//               <div style={styles.highlightBox}>
//                 <strong>Selected Date:</strong> {bookingData?.date ? formatDate(bookingData.date) : 'No date selected'}
//                 <div style={{marginTop: '10px'}}>
//                   <Button 
//                     variant="outline-primary" 
//                     size="sm"
//                     onClick={onBack}
//                   >
//                     ← Change Date
//                   </Button>
//                 </div>
//               </div>

//               {loadingSlots && (
//                 <div style={{textAlign: 'center', padding: '40px'}}>
//                   <Spinner animation="border" variant="primary" />
//                   <p style={{marginTop: '10px', color: '#666'}}>Loading available slots...</p>
//                 </div>
//               )}

//               {/* Time Slots */}
//               {!loadingSlots && bookingData?.date && (
//                 <>
//                   {allMorningSlots.length > 0 && (
//                     <>
//                       <div style={styles.sessionTitle}>
//                         Session-1 (Morning) - {allMorningSlots.filter(s => !s.isBooked).length} available
//                       </div>
//                       <div style={styles.slotsGrid}>
//                         {allMorningSlots.map((slot, index) => (
//                           <button
//                             key={index}
//                             style={{
//                               ...styles.slotButton,
//                               ...(selectedSlot === slot.value ? styles.slotButtonSelected : {}),
//                               ...(slot.isBooked ? styles.slotButtonBooked : {})
//                             }}
//                             onClick={() => handleSlotClick(slot)}
//                             disabled={slot.isBooked}
//                           >
//                             {slot.display}
//                             {slot.isBooked && <div style={{fontSize: '10px'}}>Booked</div>}
//                           </button>
//                         ))}
//                       </div>
//                     </>
//                   )}

//                   {showBreak && allMorningSlots.length > 0 && allEveningSlots.length > 0 && (
//                     <div style={styles.breakTitle}>
//                       ⏸️ Break Time (Doctor's Lunch/Rest)
//                     </div>
//                   )}

//                   {allEveningSlots.length > 0 && (
//                     <>
//                       <div style={styles.sessionTitle}>
//                         Session-2 (Evening) - {allEveningSlots.filter(s => !s.isBooked).length} available
//                       </div>
//                       <div style={styles.slotsGrid}>
//                         {allEveningSlots.map((slot, index) => (
//                           <button
//                             key={index}
//                             style={{
//                               ...styles.slotButton,
//                               ...(selectedSlot === slot.value ? styles.slotButtonSelected : {}),
//                               ...(slot.isBooked ? styles.slotButtonBooked : {})
//                             }}
//                             onClick={() => handleSlotClick(slot)}
//                             disabled={slot.isBooked}
//                           >
//                             {slot.display}
//                             {slot.isBooked && <div style={{fontSize: '10px'}}>Booked</div>}
//                           </button>
//                         ))}
//                       </div>
//                     </>
//                   )}

//                   {allMorningSlots.length === 0 && allEveningSlots.length === 0 && (
//                     <Alert variant="warning" style={{marginTop: '20px'}}>
//                       {bookingData?.schedule ? (
//                         <>
//                           <strong>No slots available for this date.</strong><br/>
//                           Please select another date or contact the clinic.
//                         </>
//                       ) : (
//                         <>
//                           <strong>Doctor schedule not set.</strong><br/>
//                           Please contact the clinic for appointment booking.
//                         </>
//                       )}
//                     </Alert>
//                   )}

//                   {totalAvailableSlots === 0 && (allMorningSlots.length > 0 || allEveningSlots.length > 0) && (
//                     <Alert variant="warning" style={{marginTop: '20px'}}>
//                       <strong>All slots are booked for this date.</strong><br/>
//                       Please select another date.
//                     </Alert>
//                   )}
//                 </>
//               )}

//               {!loadingSlots && bookingData?.date && (allMorningSlots.length > 0 || allEveningSlots.length > 0) && (
//                 <div style={{marginTop: '20px', textAlign: 'center'}}>
//                   <Button 
//                     style={styles.btnPrimary}
//                     onClick={() => setStep(2)}
//                     disabled={!selectedSlot}
//                   >
//                     Continue to Verification →
//                   </Button>
//                 </div>
//               )}
//             </div>
//           )}

//           {/* Step 2: OTP Verification */}
//           {step === 2 && (
//             <div style={styles.stepContainer}>
//               <h5 style={styles.stepTitle}>Verify Your Contact</h5>

//               {!otpSent ? (
//                 <>
//                   <div style={styles.highlightBox}>
//                     <strong>Selected Slot:</strong> {bookingData?.date ? formatDate(bookingData.date) : ''}, {selectedSlot}
//                   </div>

//                   <div style={styles.formGroup}>
//                     <label style={styles.formLabel}>
//                       Mobile Number <span style={{color: 'red'}}>*</span>
//                     </label>
//                     <input
//                       type="tel"
//                       style={styles.formInput}
//                       placeholder="Enter 10-digit mobile number"
//                       value={phoneNumber}
//                       onChange={(e) => setPhoneNumber(e.target.value)}
//                       maxLength={10}
//                     />
//                     {phoneError && <div style={{color: 'red', fontSize: '13px', marginTop: '5px'}}>{phoneError}</div>}
//                   </div>

//                   <div style={styles.formGroup}>
//                     <label style={styles.formLabel}>
//                       Email Address <span style={{color: 'red'}}>*</span>
//                     </label>
//                     <input
//                       type="email"
//                       style={styles.formInput}
//                       placeholder="Enter your email"
//                       value={email}
//                       onChange={(e) => setEmail(e.target.value)}
//                     />
//                     {emailError && <div style={{color: 'red', fontSize: '13px', marginTop: '5px'}}>{emailError}</div>}
//                   </div>

//                   <Button 
//                     style={styles.btnPrimary}
//                     onClick={sendOTP}
//                     disabled={loading}
//                   >
//                     {loading ? 'Sending OTP...' : 'Send OTP'}
//                   </Button>
//                 </>
//               ) : (
//                 <div style={styles.otpContainer}>
//                   <h6>Enter 6-Digit OTP</h6>
//                   <p style={{color: '#666', fontSize: '14px'}}>
//                     OTP sent to {email}
//                   </p>
//                   <p style={{color: '#999', fontSize: '12px', marginTop: '10px'}}>
//                     Check console for OTP (testing mode)
//                   </p>

//                   <div style={styles.otpInputs}>
//                     {otp.map((digit, index) => (
//                       <input
//                         key={index}
//                         id={`otp-${index}`}
//                         type="text"
//                         maxLength={1}
//                         style={styles.otpInput}
//                         value={digit}
//                         onChange={(e) => handleOtpChange(index, e.target.value)}
//                         onKeyDown={(e) => handleOtpKeyDown(index, e)}
//                       />
//                     ))}
//                   </div>

//                   <Button 
//                     style={styles.btnPrimary}
//                     onClick={verifyOTP}
//                     disabled={otp.join('').length !== 6}
//                   >
//                     Verify OTP
//                   </Button>

//                   <div style={{marginTop: '20px'}}>
//                     <Button 
//                       variant="link" 
//                       onClick={() => setOtpSent(false)}
//                       style={{fontSize: '14px'}}
//                     >
//                       Change Email/Phone
//                     </Button>
//                   </div>
//                 </div>
//               )}
//             </div>
//           )}

//           {/* Step 3: Patient Details */}
//           {step === 3 && (
//             <div style={styles.stepContainer}>
//               <h5 style={styles.stepTitle}>Enter Patient Details</h5>

//               <div style={styles.highlightBox}>
//                 <strong>Selected Slot:</strong> {bookingData?.date ? formatDate(bookingData.date) : ''}, {selectedSlot}
//               </div>

//               <div style={styles.formGroup}>
//                 <label style={styles.formLabel}>
//                   Patient Name <span style={{color: 'red'}}>*</span>
//                 </label>
//                 <input
//                   type="text"
//                   style={styles.formInput}
//                   placeholder="Enter patient's full name"
//                   value={patientName}
//                   onChange={(e) => setPatientName(e.target.value)}
//                 />
//                 {nameError && <div style={{color: 'red', fontSize: '13px', marginTop: '5px'}}>{nameError}</div>}
//               </div>

//               <div style={styles.healthDetailsBox}>
//                 <h6 style={{fontSize: '16px', fontWeight: '600', marginBottom: '15px', color: '#e65100'}}>
//                   🏥 Health Information 
//                 </h6>
//                 <p style={{fontSize: '13px', color: '#666', marginBottom: '15px'}}>
//                   Please provide brief details to help the doctor prepare for your consultation
//                 </p>

//                 <div style={styles.formGroup}>
//                   <label style={styles.formLabel}>
//                     Current Health Issues / Reason for Visit
//                   </label>
//                   <textarea
//                     style={styles.textArea}
//                     placeholder="E.g., Fever for 3 days, chest pain, diabetes checkup, etc."
//                     value={healthIssues}
//                     onChange={(e) => setHealthIssues(e.target.value)}
//                     maxLength={500}
//                   />
//                   <div style={{fontSize: '11px', color: '#999', textAlign: 'right', marginTop: '3px'}}>
//                     {healthIssues.length}/500 characters
//                   </div>
//                 </div>

//                 <div style={styles.formGroup}>
//                   <label style={styles.formLabel}>
//                     Medical History (if any)
//                   </label>
//                   <textarea
//                     style={styles.textArea}
//                     placeholder="E.g., Diabetes, Hypertension, Previous surgeries, Allergies, etc."
//                     value={medicalHistory}
//                     onChange={(e) => setMedicalHistory(e.target.value)}
//                     maxLength={500}
//                   />
//                   <div style={{fontSize: '11px', color: '#999', textAlign: 'right', marginTop: '3px'}}>
//                     {medicalHistory.length}/500 characters
//                   </div>
//                 </div>

//                 <div style={styles.formGroup}>
//                   <label style={styles.formLabel}>
//                     Current Medications (if any)
//                   </label>
//                   <textarea
//                     style={{...styles.textArea, minHeight: '80px'}}
//                     placeholder="E.g., Metformin 500mg twice daily, Aspirin 75mg, etc."
//                     value={currentMedications}
//                     onChange={(e) => setCurrentMedications(e.target.value)}
//                     maxLength={300}
//                   />
//                   <div style={{fontSize: '11px', color: '#999', textAlign: 'right', marginTop: '3px'}}>
//                     {currentMedications.length}/300 characters
//                   </div>
//                 </div>
//               </div>

//               <div style={{color: '#666', fontSize: '14px', marginTop: '20px'}}>
//                 <strong>Verified Contact:</strong><br/>
//                 📱 {phoneNumber}<br/>
//                 📧 {email}
//               </div>

//               <Button 
//                 style={{...styles.btnPrimary, marginTop: '30px'}}
//                 onClick={confirmBooking}
//               >
//                 Continue to Summary
//               </Button>
//             </div>
//           )}

//           {/* Step 4: Summary */}
//           {step === 4 && (
//             <div style={styles.stepContainer}>
//               <h5 style={styles.stepTitle}>Appointment Summary</h5>

//               <div style={styles.summaryCard}>
//                 <div style={styles.summarySection}>
//                   <div style={styles.summaryTitle}>
//                     👨‍⚕️ Doctor Details
//                   </div>
//                   <div style={styles.summaryRow}>
//                     <span style={styles.summaryLabel}>Doctor</span>
//                     <span style={styles.summaryValue}>
//                       Dr. {bookingData?.doctor.First} {bookingData?.doctor.Last}
//                     </span>
//                   </div>
//                   <div style={styles.summaryRow}>
//                     <span style={styles.summaryLabel}>Speciality</span>
//                     <span style={styles.summaryValue}>{bookingData?.doctor.Speciality}</span>
//                   </div>
//                   <div style={{...styles.summaryRow, borderBottom: 'none'}}>
//                     <span style={styles.summaryLabel}>Clinic</span>
//                     <span style={styles.summaryValue}>{bookingData?.doctor.ClinicName}</span>
//                   </div>
//                 </div>

//                 <div style={styles.summarySection}>
//                   <div style={styles.summaryTitle}>
//                     📅 Appointment Details
//                   </div>
//                   <div style={styles.summaryRow}>
//                     <span style={styles.summaryLabel}>Date</span>
//                     <span style={styles.summaryValue}>
//                       {bookingData?.date ? formatDate(bookingData.date) : ''}
//                     </span>
//                   </div>
//                   <div style={{...styles.summaryRow, borderBottom: 'none'}}>
//                     <span style={styles.summaryLabel}>Time</span>
//                     <span style={styles.summaryValue}>{selectedSlot}</span>
//                   </div>
//                 </div>

//                 <div style={styles.summarySection}>
//                   <div style={styles.summaryTitle}>
//                     👤 Patient Information
//                   </div>
//                   <div style={styles.summaryRow}>
//                     <span style={styles.summaryLabel}>Name</span>
//                     <span style={styles.summaryValue}>{patientName}</span>
//                   </div>
//                   <div style={styles.summaryRow}>
//                     <span style={styles.summaryLabel}>Mobile</span>
//                     <span style={styles.summaryValue}>{phoneNumber}</span>
//                   </div>
//                   <div style={{...styles.summaryRow, borderBottom: 'none'}}>
//                     <span style={styles.summaryLabel}>Email</span>
//                     <span style={styles.summaryValue}>{email}</span>
//                   </div>
//                 </div>

//                 {(healthIssues || medicalHistory || currentMedications) && (
//                   <div style={{...styles.summarySection, borderBottom: 'none', backgroundColor: '#fff3e0'}}>
//                     <div style={styles.summaryTitle}>
//                       🏥 Health Information
//                     </div>
//                     {healthIssues && (
//                       <div style={{marginBottom: '12px'}}>
//                         <div style={{...styles.summaryLabel, marginBottom: '5px'}}>Current Issues:</div>
//                         <div style={{fontSize: '13px', color: '#333', padding: '10px', backgroundColor: 'white', borderRadius: '6px'}}>
//                           {healthIssues}
//                         </div>
//                       </div>
//                     )}
//                     {medicalHistory && (
//                       <div style={{marginBottom: '12px'}}>
//                         <div style={{...styles.summaryLabel, marginBottom: '5px'}}>Medical History:</div>
//                         <div style={{fontSize: '13px', color: '#333', padding: '10px', backgroundColor: 'white', borderRadius: '6px'}}>
//                           {medicalHistory}
//                         </div>
//                       </div>
//                     )}
//                     {currentMedications && (
//                       <div>
//                         <div style={{...styles.summaryLabel, marginBottom: '5px'}}>Current Medications:</div>
//                         <div style={{fontSize: '13px', color: '#333', padding: '10px', backgroundColor: 'white', borderRadius: '6px'}}>
//                           {currentMedications}
//                         </div>
//                       </div>
//                     )}
//                   </div>
//                 )}
//               </div>

//               <Button 
//                 style={{...styles.btnSuccess, marginTop: '30px', width: '100%'}}
//                 onClick={finalizeBooking}
//                 disabled={loading}
//               >
//                 {loading ? (
//                   <>
//                     <Spinner animation="border" size="sm" style={{marginRight: '8px'}} />
//                     Booking...
//                   </>
//                 ) : (
//                   'Confirm & Book Appointment'
//                 )}
//               </Button>
//             </div>
//           )}
//         </Modal.Body>

//         <Modal.Footer style={{backgroundColor: 'white', padding: '20px 30px', borderTop: '1px solid #e0e0e0'}}>
//           <div className="d-flex justify-content-between w-100">
//             <div>
//               {step > 1 && step < 4 && (
//                 <Button 
//                   variant="outline-secondary"
//                   onClick={() => {
//                     if (step === 2 && otpSent) {
//                       setOtpSent(false);
//                     } else {
//                       setStep(step - 1);
//                     }
//                   }}
//                 >
//                   ← Back
//                 </Button>
//               )}
//             </div>
//             <Button variant="outline-danger" onClick={handleModalClose}>
//               Cancel
//             </Button>
//           </div>
//         </Modal.Footer>
//       </div>
//     </Modal>
//   );
// };

// export default TimeSlotModal;

import React, { useState, useEffect } from "react";
import { Modal, Button, Alert, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import { getDatabase, ref, get, set, update } from "firebase/database";
import { app } from "../../../Doctor/Firebase/firebase.config";
import { useAuth } from "../../AuthContext";
import emailjs from "@emailjs/browser";

const database = getDatabase(app);

// ==================== EMAILJS CONFIGURATION ====================
const EMAILJS_SERVICE_ID = 'service_cab38e6';
const EMAILJS_OTP_TEMPLATE_ID = 'template_h08g4fm';
const EMAILJS_CONFIRMATION_TEMPLATE_ID = 'template_c2m3r4j';
const EMAILJS_PUBLIC_KEY = 'rnBYIQUEQDDpqOcl1';

// ==================== STYLES ====================
const styles = {
  modalContent: {
    borderRadius: '16px',
    border: 'none',
    boxShadow: '0 10px 40px rgba(0, 0, 0, 0.1)',
    overflow: 'hidden'
  },
  modalHeader: {
    background: 'linear-gradient(135deg, #4285f4 0%, #34a853 100%)',
    color: 'white',
    padding: '20px 30px',
    borderBottom: 'none'
  },
  doctorInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: '15px'
  },
  doctorAvatar: {
    width: '60px',
    height: '60px',
    borderRadius: '50%',
    backgroundColor: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '24px',
    fontWeight: 'bold',
    color: '#4285f4'
  },
  doctorDetails: {
    flex: 1
  },
  doctorName: {
    fontSize: '20px',
    fontWeight: '600',
    margin: 0,
    color: 'white'
  },
  doctorSpeciality: {
    fontSize: '14px',
    opacity: 0.9,
    margin: 0,
    color: 'white'
  },
  modalBody: {
    padding: '30px',
    backgroundColor: '#f8f9fa',
    minHeight: '500px'
  },
  progressBar: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '30px',
    position: 'relative',
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '12px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)'
  },
  progressStep: {
    flex: 1,
    textAlign: 'center',
    position: 'relative',
    zIndex: 2
  },
  progressCircle: {
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    backgroundColor: '#e0e0e0',
    color: '#666',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 8px',
    fontWeight: 'bold',
    fontSize: '16px',
    transition: 'all 0.3s ease'
  },
  progressCircleActive: {
    backgroundColor: '#4285f4',
    color: 'white',
    boxShadow: '0 4px 12px rgba(66, 133, 244, 0.4)'
  },
  progressCircleCompleted: {
    backgroundColor: '#34a853',
    color: 'white'
  },
  progressLabel: {
    fontSize: '12px',
    color: '#666',
    fontWeight: '500'
  },
  progressLabelActive: {
    color: '#4285f4',
    fontWeight: '600'
  },
  stepContainer: {
    backgroundColor: 'white',
    padding: '30px',
    borderRadius: '12px',
    boxShadow: '0 2px 12px rgba(0, 0, 0, 0.06)',
    minHeight: '400px'
  },
  stepTitle: {
    fontSize: '22px',
    fontWeight: '700',
    color: '#333',
    marginBottom: '25px',
    paddingBottom: '15px',
    borderBottom: '3px solid #4285f4'
  },
  sessionTitle: {
    backgroundColor: '#f1f3f4',
    padding: '12px 20px',
    borderRadius: '8px',
    fontWeight: '600',
    color: '#333',
    marginBottom: '15px',
    marginTop: '20px'
  },
  breakTitle: {
    backgroundColor: '#fff3cd',
    padding: '12px 20px',
    borderRadius: '8px',
    fontWeight: '600',
    color: '#856404',
    marginBottom: '15px',
    marginTop: '20px',
    textAlign: 'center',
    border: '1px solid #ffeaa7'
  },
  slotsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(110px, 1fr))',
    gap: '10px',
    marginBottom: '20px'
  },
  slotButton: {
    padding: '10px',
    borderRadius: '8px',
    border: '2px solid #e0e0e0',
    backgroundColor: 'white',
    fontSize: '13px',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    textAlign: 'center',
    minHeight: '50px'
  },
  slotButtonSelected: {
    backgroundColor: '#4285f4',
    color: 'white',
    border: '2px solid #4285f4',
    fontWeight: '600'
  },
  slotButtonBooked: {
    backgroundColor: '#f5f5f5',
    color: '#999',
    border: '2px solid #e0e0e0',
    cursor: 'not-allowed',
    textDecoration: 'line-through'
  },
  otpContainer: {
    textAlign: 'center',
    padding: '40px 20px'
  },
  otpInputs: {
    display: 'flex',
    justifyContent: 'center',
    gap: '15px',
    marginTop: '30px',
    marginBottom: '30px'
  },
  otpInput: {
    width: '55px',
    height: '55px',
    fontSize: '24px',
    fontWeight: 'bold',
    textAlign: 'center',
    border: '2px solid #e0e0e0',
    borderRadius: '12px',
    transition: 'all 0.3s ease'
  },
  formGroup: {
    marginBottom: '20px'
  },
  formLabel: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#333',
    marginBottom: '8px',
    display: 'block'
  },
  formInput: {
    width: '100%',
    padding: '12px 15px',
    fontSize: '15px',
    border: '2px solid #e0e0e0',
    borderRadius: '8px',
    transition: 'all 0.3s ease'
  },
  textArea: {
    width: '100%',
    padding: '12px 15px',
    fontSize: '14px',
    border: '2px solid #e0e0e0',
    borderRadius: '8px',
    minHeight: '120px',
    fontFamily: 'inherit',
    resize: 'vertical'
  },
  summaryCard: {
    backgroundColor: 'white',
    borderRadius: '12px',
    overflow: 'hidden',
    border: '1px solid #e0e0e0'
  },
  summarySection: {
    padding: '20px',
    borderBottom: '1px solid #f0f0f0'
  },
  summaryTitle: {
    fontSize: '16px',
    fontWeight: '700',
    color: '#333',
    marginBottom: '15px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  summaryRow: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '10px 0',
    borderBottom: '1px solid #f8f9fa'
  },
  summaryLabel: {
    fontSize: '14px',
    color: '#666',
    fontWeight: '500'
  },
  summaryValue: {
    fontSize: '14px',
    color: '#333',
    fontWeight: '600',
    textAlign: 'right'
  },
  highlightBox: {
    backgroundColor: '#e8f0fe',
    padding: '15px',
    borderRadius: '8px',
    marginBottom: '15px',
    border: '1px solid #4285f4'
  },
  healthDetailsBox: {
    backgroundColor: '#fff3e0',
    padding: '15px',
    borderRadius: '8px',
    marginTop: '15px',
    border: '1px solid #ff9800'
  },
  btnPrimary: {
    backgroundColor: '#4285f4',
    border: 'none',
    padding: '12px 30px',
    fontSize: '15px',
    fontWeight: '600',
    borderRadius: '8px',
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: '#3367d6',
      transform: 'translateY(-2px)'
    }
  },
  btnSuccess: {
    backgroundColor: '#34a853',
    border: 'none',
    padding: '12px 30px',
    fontSize: '15px',
    fontWeight: '600',
    borderRadius: '8px',
    '&:hover': {
      backgroundColor: '#2d8b47',
      transform: 'translateY(-2px)'
    }
  }
};

// Generate time slots with 15-minute intervals
const generateTimeSlots = (startTime, endTime) => {
  const slots = [];
  
  const parseTime = (timeStr) => {
    if (!timeStr) return null;
    const [hours, minutes] = timeStr.split(':').map(Number);
    const date = new Date();
    date.setHours(hours, minutes || 0, 0, 0);
    return date;
  };
  
  const start = parseTime(startTime);
  const end = parseTime(endTime);
  
  if (!start || !end || end <= start) {
    console.error("Invalid time range:", startTime, endTime);
    return slots;
  }
  
  const current = new Date(start);
  
  while (current < end) {
    const hours = current.getHours();
    const minutes = current.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const displayHours = hours % 12 || 12;
    const displayMinutes = minutes < 10 ? '0' + minutes : minutes;
    
    slots.push({
      display: `${displayHours}:${displayMinutes} ${ampm}`,
      value: `${displayHours}:${displayMinutes} ${ampm}`,
      time24: `${hours.toString().padStart(2, '0')}:${displayMinutes}`
    });
    
    current.setTime(current.getTime() + 15 * 60000);
  }
  
  return slots;
};

// Check if there should be a break between morning and evening
const calculateBreakNeeded = (morningEndTime, eveningStartTime) => {
  if (!morningEndTime || !eveningStartTime) return false;
  
  const parseTime = (timeStr) => {
    const [hours, minutes] = timeStr.split(':').map(Number);
    const date = new Date();
    date.setHours(hours, minutes || 0, 0, 0);
    return date;
  };
  
  const morningEnd = parseTime(morningEndTime);
  const eveningStart = parseTime(eveningStartTime);
  
  if (!morningEnd || !eveningStart) return false;
  
  const timeDiff = (eveningStart - morningEnd) / (1000 * 60);
  
  return timeDiff >= 30;
};

const TimeSlotModal = ({ show, handleClose, bookingData, onBack, onBookingComplete }) => {
  const { user } = useAuth();
  
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [loadingSlots, setLoadingSlots] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [generatedOTP, setGeneratedOTP] = useState('');
  
  // Step 1: Time Selection
  const [selectedSlot, setSelectedSlot] = useState('');
  const [allMorningSlots, setAllMorningSlots] = useState([]);
  const [allEveningSlots, setAllEveningSlots] = useState([]);
  const [bookedSlots, setBookedSlots] = useState([]);
  const [showBreak, setShowBreak] = useState(false);
  
  // Step 2: OTP Verification
  const [phoneNumber, setPhoneNumber] = useState('');
  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState(['', '', '', '', '', '']);
  const [phoneError, setPhoneError] = useState('');
  const [emailError, setEmailError] = useState('');
  
  // Step 3: Patient Details
  const [patientName, setPatientName] = useState('');
  const [patientAge, setPatientAge] = useState('');
  const [nameError, setNameError] = useState('');
  const [ageError, setAgeError] = useState('');
  const [healthIssues, setHealthIssues] = useState('');
  const [medicalHistory, setMedicalHistory] = useState('');
  const [currentMedications, setCurrentMedications] = useState('');

  // Load time slots when modal opens
  useEffect(() => {
    if (!show || !bookingData || !bookingData.doctor) return;

    const fetchBookedSlots = async () => {
      try {
        setLoadingSlots(true);
        
        const appointmentsRef = ref(database, `doctor/${bookingData.doctor.uid}/appointments`);
        const appointmentsSnapshot = await get(appointmentsRef);
        
        if (appointmentsSnapshot.exists()) {
          const appointmentsData = appointmentsSnapshot.val();
          console.log("✅ Booked appointments found:", appointmentsData);
          
          // Convert to array
          const bookedArray = Object.values(appointmentsData);
          console.log("📋 Booked appointments array:", bookedArray);
          setBookedSlots(bookedArray);
        } else {
          console.log("ℹ️ No booked appointments found");
          setBookedSlots([]);
        }
      } catch (error) {
        console.error("❌ Error fetching appointments:", error);
        toast.error("Failed to load appointments");
      } finally {
        setLoadingSlots(false);
      }
    };

    fetchBookedSlots();
  }, [show, bookingData]);

  // Generate slots when modal opens or when booked slots change
  useEffect(() => {
    if (!bookingData || !bookingData.schedule) {
      setAllMorningSlots([]);
      setAllEveningSlots([]);
      setShowBreak(false);
      return;
    }

    console.log("📅 Booking data:", bookingData);
    console.log("⏰ Doctor schedule:", bookingData.schedule);
    
    let morning = [];
    if (bookingData.schedule.morningStartTime && bookingData.schedule.morningEndTime) {
      console.log(`🌅 Generating morning slots: ${bookingData.schedule.morningStartTime} to ${bookingData.schedule.morningEndTime}`);
      morning = generateTimeSlots(
        bookingData.schedule.morningStartTime,
        bookingData.schedule.morningEndTime
      );
      console.log("✅ Morning slots generated:", morning.length, morning);
    }

    let evening = [];
    if (bookingData.schedule.eveningStartTime && bookingData.schedule.eveningEndTime) {
      console.log(`🌇 Generating evening slots: ${bookingData.schedule.eveningStartTime} to ${bookingData.schedule.eveningEndTime}`);
      evening = generateTimeSlots(
        bookingData.schedule.eveningStartTime,
        bookingData.schedule.eveningEndTime
      );
      console.log("✅ Evening slots generated:", evening.length, evening);
    }

    const hasBreak = calculateBreakNeeded(
      bookingData.schedule.morningEndTime,
      bookingData.schedule.eveningStartTime
    );
    setShowBreak(hasBreak);

    const formattedDate = bookingData.date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    });
    
    console.log("📆 Formatted date for booking check:", formattedDate);
    console.log("📊 Current booked slots:", bookedSlots);
    
    const markBookedSlots = (slots) => {
      return slots.map(slot => {
        const isBooked = bookedSlots.some(booking => {
          if (!booking.date || !booking.timeSlot) return false;
          
          const bookingDate = new Date(booking.date).toLocaleDateString('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
          });
          
          console.log(`Comparing: Booking Date ${bookingDate} vs Selected Date ${formattedDate}, Time: ${booking.timeSlot} vs ${slot.value}`);
          
          return bookingDate === formattedDate && booking.timeSlot === slot.value;
        });
        
        if (isBooked) {
          console.log(`❌ Slot ${slot.value} is booked`);
        }
        
        return { ...slot, isBooked };
      });
    };

    setAllMorningSlots(markBookedSlots(morning));
    setAllEveningSlots(markBookedSlots(evening));

    console.log("📈 Total morning slots:", morning.length);
    console.log("📈 Total evening slots:", evening.length);
    console.log("⏸️ Show break:", hasBreak);

  }, [bookingData, bookedSlots]);

  // Send OTP
  const sendOTP = async () => {
    setPhoneError('');
    setEmailError('');

    // Validate patient name
    if (!patientName.trim()) {
      setNameError('Patient name is required');
      toast.error('Please enter patient name');
      return;
    }

    if (!phoneNumber.trim()) {
      setPhoneError('Phone number is required');
      return;
    }
    if (!/^[6-9]\d{9}$/.test(phoneNumber)) {
      setPhoneError('Enter valid 10-digit mobile number');
      return;
    }
    if (!email.trim()) {
      setEmailError('Email is required');
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setEmailError('Enter valid email address');
      return;
    }

    setLoading(true);
    
    const otp = Math.floor(100000 + Math.random() * 900000).toString();
    setGeneratedOTP(otp);
    console.log("🔐 Generated OTP (for testing):", otp);

    try {
      const expiryTime = new Date();
      expiryTime.setMinutes(expiryTime.getMinutes() + 15);
      const expiryTimeStr = expiryTime.toLocaleTimeString('en-US', { 
        hour: '2-digit', 
        minute: '2-digit',
        hour12: true 
      });

      const otpMessage = `Your OTP is: ${otp}\n\nThis OTP will be valid until ${expiryTimeStr}`;
      
      const emailParams = {
        to_email: email,
        to_name: patientName || 'Patient',
        message: otpMessage,
        passcode: otp,
        time: expiryTimeStr,
        otp: otp,
        otp_code: otp,
        OTP: otp,
        PASSCODE: otp,
        expiry_time: expiryTimeStr,
        valid_until: expiryTimeStr,
        phone_number: phoneNumber,
        doctor_name: `Dr. ${bookingData?.doctor?.First || ''} ${bookingData?.doctor?.Last || ''}`,
        appointment_date: bookingData?.date ? bookingData.date.toLocaleDateString('en-US', { 
          weekday: 'long',
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        }) : '',
        appointment_time: selectedSlot
      };

      console.log('📧 Sending OTP email with params:', emailParams);

      const response = await emailjs.send(
        EMAILJS_SERVICE_ID,
        EMAILJS_OTP_TEMPLATE_ID,
        emailParams,
        EMAILJS_PUBLIC_KEY
      );

      console.log('📧 EmailJS Response:', response);

      if (response.status === 200) {
        setOtpSent(true);
        toast.success(`OTP sent successfully to ${email}. Please check your inbox.`);
      } else {
        throw new Error('Email send failed with status: ' + response.status);
      }
    } catch (error) {
      console.error('❌ Error sending OTP:', error);
      
      if (error.text) {
        toast.error(`Failed to send OTP: ${error.text}`);
      } else {
        toast.error('Failed to send OTP. Please check your email address and try again.');
      }
      
      // For development, show OTP in toast
      toast.info(`Development Mode - OTP: ${otp}`, { 
        autoClose: false,
        position: "top-right"
      });
    } finally {
      setLoading(false);
    }
  };

  // Verify OTP
  const verifyOTP = () => {
    const enteredOTP = otp.join('');
    console.log("🔐 Entered OTP:", enteredOTP, "Generated OTP:", generatedOTP);
    
    if (enteredOTP === generatedOTP) {
      toast.success('OTP verified successfully!');
      setStep(3);
    } else {
      toast.error('Invalid OTP. Please try again.');
    }
  };

  // Handle OTP input
  const handleOtpChange = (index, value) => {
    if (!/^\d*$/.test(value)) return;
    
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 5) {
      const nextInput = document.getElementById(`otp-${index + 1}`);
      if (nextInput) nextInput.focus();
    }
  };

  // Handle OTP backspace
  const handleOtpKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      const prevInput = document.getElementById(`otp-${index - 1}`);
      if (prevInput) prevInput.focus();
    }
  };

  // Confirm patient details
  const confirmBooking = async () => {
    setNameError('');
    setAgeError('');

    if (!patientName.trim()) {
      setNameError('Name is required');
      toast.error('Please enter patient name');
      return;
    }

    if (!patientAge.trim()) {
      setAgeError('Age is required');
      toast.error('Please enter patient age');
      return;
    }

    if (isNaN(patientAge) || parseInt(patientAge) < 0 || parseInt(patientAge) > 150) {
      setAgeError('Please enter a valid age (0-150)');
      toast.error('Please enter a valid age');
      return;
    }

    if (!phoneNumber.trim()) {
      toast.error('Phone number is required');
      return;
    }

    if (!email.trim()) {
      toast.error('Email is required');
      return;
    }

    console.log("✅ All details validated, moving to step 4");
    setStep(4);
  };

  // Final booking
  const finalizeBooking = async () => {
    if (!user || !user.userId) {
      toast.error('Please login to book appointment');
      return;
    }

    if (!selectedSlot) {
      toast.error('Please select a time slot');
      return;
    }

    if (!patientName || !patientAge || !phoneNumber || !email) {
      toast.error('Please fill all required fields');
      return;
    }

    setLoading(true);

    try {
      // Create unique appointment ID
      const appointmentId = `apt_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
      
      // Format date for storage
      const appointmentDate = bookingData.date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });
      
      // Create appointment data with ALL required fields
      const appointmentData = {
        // Core appointment info
        appointmentId: appointmentId,
        id: appointmentId,
        
        // Patient Information
        patientID: user.userId,
        patientName: patientName.trim(),
        patientAge: patientAge.trim(),
        patientPhone: phoneNumber.trim(),
        patientEmail: email.trim(),
        patientMobile: phoneNumber.trim(),
        
        // Appointment Details
        date: appointmentDate,
        appointmentDate: appointmentDate,
        timeSlot: selectedSlot,
        appointmentTime: selectedSlot,
        
        // Health Information
        symptoms: healthIssues.trim() || 'Not provided',
        healthIssues: healthIssues.trim() || 'Not provided',
        description: healthIssues.trim() || 'Not provided',
        medicalHistory: medicalHistory.trim() || 'None provided',
        currentMedications: currentMedications.trim() || 'None provided',
        medications: currentMedications.trim() || 'None provided',
        
        // Doctor Information
        doctorId: bookingData.doctor.uid,
        doctorUID: bookingData.doctor.uid,
        doctorName: `Dr. ${bookingData.doctor.First} ${bookingData.doctor.Last}`,
        speciality: bookingData.doctor.Speciality || 'General Physician',
        clinicName: bookingData.doctor.ClinicName || "Doctor's Clinic",
        
        // Booking Status
        status: 'Confirmed',
        paymentStatus: 'Pending',
        payment: 'Pending',
        paymentMethod: 'Not specified',
        
        // Timestamps
        bookingDate: new Date().toISOString(),
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString()
      };

      console.log("💾 Appointment data to be saved:", appointmentData);
      console.log("📍 Saving to doctor path: doctor/" + bookingData.doctor.uid + "/appointments/" + appointmentId);
      console.log("📍 Saving to user path: users/" + user.userId + "/appointments/" + appointmentId);

      // Save to doctor's appointments
      const doctorAppointmentRef = ref(database, `doctor/${bookingData.doctor.uid}/appointments/${appointmentId}`);
      await set(doctorAppointmentRef, appointmentData);
      console.log("✅ Saved to doctor's appointments");

      // Save to user's appointments
      const userAppointmentRef = ref(database, `users/${user.userId}/appointments/${appointmentId}`);
      await set(userAppointmentRef, appointmentData);
      console.log("✅ Saved to user's appointments");

      // Also update user profile with their basic info
      try {
        const userProfileRef = ref(database, `users/${user.userId}`);
        const updates = {
          name: patientName.trim(),
          email: email.trim(),
          mobile: phoneNumber.trim(),
          age: patientAge.trim(),
          updatedAt: new Date().toISOString()
        };
        
        await update(userProfileRef, updates);
        console.log("✅ Updated user profile with:", updates);
      } catch (profileError) {
        console.error("⚠️ Error updating user profile:", profileError);
        // Continue even if profile update fails
      }

      // Send confirmation email
      try {
        const confirmationParams = {
          Patient_Email: email,
          Patient_Name: patientName,
          Doctor_Name: `Dr. ${bookingData.doctor.First} ${bookingData.doctor.Last}`,
          Apn_Date: bookingData.date.toLocaleDateString('en-US', {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          }),
          Apn_Time: selectedSlot,
          Doctor_Speciality: bookingData.doctor.Speciality,
          Clinic_Name: bookingData.doctor.ClinicName || "Doctor's Clinic",
          Appointment_ID: appointmentId,
          Booking_Date: new Date().toLocaleDateString('en-US', {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })
        };
        
        console.log('📧 Sending confirmation email with params:', confirmationParams);
        
        await emailjs.send(
          EMAILJS_SERVICE_ID,
          EMAILJS_CONFIRMATION_TEMPLATE_ID,
          confirmationParams,
          EMAILJS_PUBLIC_KEY
        );
        console.log("✅ Confirmation email sent successfully");
      } catch (emailError) {
        console.error("⚠️ Email send error:", emailError);
        toast.warning("Appointment booked but confirmation email failed to send.");
      }

      toast.success('🎉 Appointment booked successfully!');
      
      // Reset form
      setPatientName('');
      setPatientAge('');
      setPhoneNumber('');
      setEmail('');
      setHealthIssues('');
      setMedicalHistory('');
      setCurrentMedications('');
      setSelectedSlot('');
      setOtpSent(false);
      setOtp(['', '', '', '', '', '']);
      setStep(1);
      
      // Call onBookingComplete callback
      if (onBookingComplete) {
        onBookingComplete();
      }
      
      // Close modal after delay
      setTimeout(() => {
        handleModalClose();
      }, 2000);
    } catch (error) {
      console.error('❌ Error booking:', error);
      toast.error('Booking failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleModalClose = () => {
    setStep(1);
    setSelectedSlot('');
    setPhoneNumber('');
    setEmail('');
    setOtp(['', '', '', '', '', '']);
    setPatientName('');
    setPatientAge('');
    setHealthIssues('');
    setMedicalHistory('');
    setCurrentMedications('');
    setOtpSent(false);
    setShowBreak(false);
    handleClose();
  };

  const formatDate = (date) => {
    if (!date) return '';
    return date.toLocaleDateString('en-US', { 
      weekday: 'long',
      month: 'long', 
      day: 'numeric',
      year: 'numeric'
    });
  };

  const handleSlotClick = (slot) => {
    if (slot.isBooked) {
      toast.warning('This slot is already booked. Please select another slot.');
      return;
    }
    console.log("⏰ Selected slot:", slot.value);
    setSelectedSlot(slot.value);
  };

  const totalAvailableSlots = allMorningSlots.filter(s => !s.isBooked).length + 
                               allEveningSlots.filter(s => !s.isBooked).length;

  return (
    <Modal show={show} onHide={handleModalClose} size="lg" centered>
      <div style={styles.modalContent}>
        <Modal.Header closeButton style={styles.modalHeader}>
          <div style={styles.doctorInfo}>
            <div style={styles.doctorAvatar}>
              {bookingData?.doctor?.First?.charAt(0) || 'D'}{bookingData?.doctor?.Last?.charAt(0) || 'R'}
            </div>
            <div style={styles.doctorDetails}>
              <h4 style={styles.doctorName}>
                Dr. {bookingData?.doctor?.First || ''} {bookingData?.doctor?.Last || ''}
              </h4>
              <p style={styles.doctorSpeciality}>
                {bookingData?.doctor?.Speciality || 'General Physician'}
              </p>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body style={styles.modalBody}>
          {/* Progress Bar */}
          <div style={styles.progressBar}>
            <div style={styles.progressStep}>
              <div style={{
                ...styles.progressCircle,
                ...styles.progressCircleCompleted
              }}>
                ✓
              </div>
              <div style={styles.progressLabel}>
                Select Date
              </div>
            </div>

            <div style={styles.progressStep}>
              <div style={{
                ...styles.progressCircle,
                ...(step >= 1 ? styles.progressCircleActive : {}),
                ...(step > 1 ? styles.progressCircleCompleted : {})
              }}>
                {step > 1 ? '✓' : '2'}
              </div>
              <div style={{
                ...styles.progressLabel,
                ...(step === 1 ? styles.progressLabelActive : {})
              }}>
                Select Time
              </div>
            </div>

            <div style={styles.progressStep}>
              <div style={{
                ...styles.progressCircle,
                ...(step >= 3 ? styles.progressCircleActive : {}),
                ...(step > 3 ? styles.progressCircleCompleted : {})
              }}>
                {step > 3 ? '✓' : '3'}
              </div>
              <div style={{
                ...styles.progressLabel,
                ...(step === 3 ? styles.progressLabelActive : {})
              }}>
                Verify & Book
              </div>
            </div>
          </div>

          {/* Step 1: Select Time */}
          {step === 1 && (
            <div style={styles.stepContainer}>
              <h5 style={styles.stepTitle}>
                Select Time Slot
              </h5>

              <div style={styles.highlightBox}>
                <strong>Selected Date:</strong> {bookingData?.date ? formatDate(bookingData.date) : 'No date selected'}
                <div style={{marginTop: '10px'}}>
                  <Button 
                    variant="outline-primary" 
                    size="sm"
                    onClick={onBack}
                  >
                    ← Change Date
                  </Button>
                </div>
              </div>

              {loadingSlots && (
                <div style={{textAlign: 'center', padding: '40px'}}>
                  <Spinner animation="border" variant="primary" />
                  <p style={{marginTop: '10px', color: '#666'}}>Loading available slots...</p>
                </div>
              )}

              {/* Time Slots */}
              {!loadingSlots && bookingData?.date && (
                <>
                  {allMorningSlots.length > 0 && (
                    <>
                      <div style={styles.sessionTitle}>
                        Session-1 (Morning) - {allMorningSlots.filter(s => !s.isBooked).length} available
                      </div>
                      <div style={styles.slotsGrid}>
                        {allMorningSlots.map((slot, index) => (
                          <button
                            key={index}
                            style={{
                              ...styles.slotButton,
                              ...(selectedSlot === slot.value ? styles.slotButtonSelected : {}),
                              ...(slot.isBooked ? styles.slotButtonBooked : {})
                            }}
                            onClick={() => handleSlotClick(slot)}
                            disabled={slot.isBooked}
                          >
                            {slot.display}
                            {slot.isBooked && <div style={{fontSize: '10px', color: '#666'}}>Booked</div>}
                          </button>
                        ))}
                      </div>
                    </>
                  )}

                  {showBreak && allMorningSlots.length > 0 && allEveningSlots.length > 0 && (
                    <div style={styles.breakTitle}>
                      ⏸️ Break Time (Doctor's Lunch/Rest)
                    </div>
                  )}

                  {allEveningSlots.length > 0 && (
                    <>
                      <div style={styles.sessionTitle}>
                        Session-2 (Evening) - {allEveningSlots.filter(s => !s.isBooked).length} available
                      </div>
                      <div style={styles.slotsGrid}>
                        {allEveningSlots.map((slot, index) => (
                          <button
                            key={index}
                            style={{
                              ...styles.slotButton,
                              ...(selectedSlot === slot.value ? styles.slotButtonSelected : {}),
                              ...(slot.isBooked ? styles.slotButtonBooked : {})
                            }}
                            onClick={() => handleSlotClick(slot)}
                            disabled={slot.isBooked}
                          >
                            {slot.display}
                            {slot.isBooked && <div style={{fontSize: '10px', color: '#666'}}>Booked</div>}
                          </button>
                        ))}
                      </div>
                    </>
                  )}

                  {allMorningSlots.length === 0 && allEveningSlots.length === 0 && (
                    <Alert variant="warning" style={{marginTop: '20px'}}>
                      {bookingData?.schedule ? (
                        <>
                          <strong>No slots available for this date.</strong><br/>
                          Please select another date or contact the clinic.
                        </>
                      ) : (
                        <>
                          <strong>Doctor schedule not set.</strong><br/>
                          Please contact the clinic for appointment booking.
                        </>
                      )}
                    </Alert>
                  )}

                  {totalAvailableSlots === 0 && (allMorningSlots.length > 0 || allEveningSlots.length > 0) && (
                    <Alert variant="warning" style={{marginTop: '20px'}}>
                      <strong>All slots are booked for this date.</strong><br/>
                      Please select another date.
                    </Alert>
                  )}

                  {!loadingSlots && bookingData?.date && (allMorningSlots.length > 0 || allEveningSlots.length > 0) && (
                    <div style={{marginTop: '20px', textAlign: 'center'}}>
                      <Button 
                        variant="primary"
                        style={styles.btnPrimary}
                        onClick={() => {
                          if (!selectedSlot) {
                            toast.error('Please select a time slot');
                            return;
                          }
                          console.log("Proceeding to step 2 with slot:", selectedSlot);
                          setStep(2);
                        }}
                        disabled={!selectedSlot}
                      >
                        Continue to Verification →
                      </Button>
                    </div>
                  )}
                </>
              )}
            </div>
          )}

          {/* Step 2: OTP Verification */}
          {step === 2 && (
            <div style={styles.stepContainer}>
              <h5 style={styles.stepTitle}>Verify Your Contact</h5>

              {!otpSent ? (
                <>
                  <div style={styles.highlightBox}>
                    <strong>Selected Slot:</strong> {bookingData?.date ? formatDate(bookingData.date) : ''}, {selectedSlot}
                  </div>

                  <div style={styles.formGroup}>
                    <label style={styles.formLabel}>
                      Patient Name <span style={{color: 'red'}}>*</span>
                    </label>
                    <input
                      type="text"
                      style={styles.formInput}
                      placeholder="Enter patient's full name"
                      value={patientName}
                      onChange={(e) => setPatientName(e.target.value)}
                      required
                    />
                    {nameError && <div style={{color: 'red', fontSize: '13px', marginTop: '5px'}}>{nameError}</div>}
                  </div>

                  <div style={styles.formGroup}>
                    <label style={styles.formLabel}>
                      Mobile Number <span style={{color: 'red'}}>*</span>
                    </label>
                    <input
                      type="tel"
                      style={styles.formInput}
                      placeholder="Enter 10-digit mobile number"
                      value={phoneNumber}
                      onChange={(e) => setPhoneNumber(e.target.value)}
                      maxLength={10}
                      required
                    />
                    {phoneError && <div style={{color: 'red', fontSize: '13px', marginTop: '5px'}}>{phoneError}</div>}
                  </div>

                  <div style={styles.formGroup}>
                    <label style={styles.formLabel}>
                      Email Address <span style={{color: 'red'}}>*</span>
                    </label>
                    <input
                      type="email"
                      style={styles.formInput}
                      placeholder="Enter your email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                    {emailError && <div style={{color: 'red', fontSize: '13px', marginTop: '5px'}}>{emailError}</div>}
                  </div>

                  <Button 
                    variant="primary"
                    style={styles.btnPrimary}
                    onClick={sendOTP}
                    disabled={loading || !patientName || !phoneNumber || !email}
                  >
                    {loading ? (
                      <>
                        <Spinner animation="border" size="sm" style={{marginRight: '8px'}} />
                        Sending OTP...
                      </>
                    ) : (
                      'Send OTP'
                    )}
                  </Button>
                </>
              ) : (
                <div style={styles.otpContainer}>
                  <h6>Enter 6-Digit OTP</h6>
                  <p style={{color: '#666', fontSize: '14px'}}>
                    OTP sent to {email}
                  </p>
                  <p style={{color: '#999', fontSize: '12px', marginTop: '10px'}}>
                    Check console for OTP (testing mode)
                  </p>

                  <div style={styles.otpInputs}>
                    {otp.map((digit, index) => (
                      <input
                        key={index}
                        id={`otp-${index}`}
                        type="text"
                        maxLength={1}
                        style={styles.otpInput}
                        value={digit}
                        onChange={(e) => handleOtpChange(index, e.target.value)}
                        onKeyDown={(e) => handleOtpKeyDown(index, e)}
                        autoFocus={index === 0}
                      />
                    ))}
                  </div>

                  <Button 
                    variant="primary"
                    style={styles.btnPrimary}
                    onClick={verifyOTP}
                    disabled={otp.join('').length !== 6}
                  >
                    Verify OTP
                  </Button>

                  <div style={{marginTop: '20px'}}>
                    <Button 
                      variant="link" 
                      onClick={() => setOtpSent(false)}
                      style={{fontSize: '14px', color: '#4285f4'}}
                    >
                      Change Email/Phone
                    </Button>
                  </div>
                </div>
              )}
            </div>
          )}

          {/* Step 3: Patient Details */}
          {step === 3 && (
            <div style={styles.stepContainer}>
              <h5 style={styles.stepTitle}>Enter Additional Details</h5>

              <div style={styles.highlightBox}>
                <strong>Selected Slot:</strong> {bookingData?.date ? formatDate(bookingData.date) : ''}, {selectedSlot}
              </div>

              <div style={styles.formGroup}>
                <label style={styles.formLabel}>
                  Patient Age <span style={{color: 'red'}}>*</span>
                </label>
                <input
                  type="number"
                  style={styles.formInput}
                  placeholder="Enter patient's age"
                  value={patientAge}
                  onChange={(e) => setPatientAge(e.target.value)}
                  min="0"
                  max="150"
                  required
                />
                {ageError && <div style={{color: 'red', fontSize: '13px', marginTop: '5px'}}>{ageError}</div>}
              </div>

              <div style={styles.healthDetailsBox}>
                <h6 style={{fontSize: '16px', fontWeight: '600', marginBottom: '15px', color: '#e65100'}}>
                  🏥 Health Information 
                </h6>
                <p style={{fontSize: '13px', color: '#666', marginBottom: '15px'}}>
                  Please provide brief details to help the doctor prepare for your consultation
                </p>

                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>
                    Current Health Issues / Reason for Visit
                  </label>
                  <textarea
                    style={styles.textArea}
                    placeholder="E.g., Fever for 3 days, chest pain, diabetes checkup, etc."
                    value={healthIssues}
                    onChange={(e) => setHealthIssues(e.target.value)}
                    maxLength={500}
                  />
                  <div style={{fontSize: '11px', color: '#999', textAlign: 'right', marginTop: '3px'}}>
                    {healthIssues.length}/500 characters
                  </div>
                </div>

                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>
                    Medical History (if any)
                  </label>
                  <textarea
                    style={styles.textArea}
                    placeholder="E.g., Diabetes, Hypertension, Previous surgeries, Allergies, etc."
                    value={medicalHistory}
                    onChange={(e) => setMedicalHistory(e.target.value)}
                    maxLength={500}
                  />
                  <div style={{fontSize: '11px', color: '#999', textAlign: 'right', marginTop: '3px'}}>
                    {medicalHistory.length}/500 characters
                  </div>
                </div>

                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>
                    Current Medications (if any)
                  </label>
                  <textarea
                    style={{...styles.textArea, minHeight: '80px'}}
                    placeholder="E.g., Metformin 500mg twice daily, Aspirin 75mg, etc."
                    value={currentMedications}
                    onChange={(e) => setCurrentMedications(e.target.value)}
                    maxLength={300}
                  />
                  <div style={{fontSize: '11px', color: '#999', textAlign: 'right', marginTop: '3px'}}>
                    {currentMedications.length}/300 characters
                  </div>
                </div>
              </div>

              <div style={{color: '#666', fontSize: '14px', marginTop: '20px', padding: '10px', backgroundColor: '#f8f9fa', borderRadius: '8px'}}>
                <strong>Verified Contact:</strong><br/>
                📱 {phoneNumber}<br/>
                📧 {email}
              </div>

              <Button 
                variant="primary"
                style={{...styles.btnPrimary, marginTop: '30px'}}
                onClick={confirmBooking}
                disabled={!patientAge}
              >
                Continue to Summary →
              </Button>
            </div>
          )}

          {/* Step 4: Summary */}
          {step === 4 && (
            <div style={styles.stepContainer}>
              <h5 style={styles.stepTitle}>Appointment Summary</h5>

              <div style={styles.summaryCard}>
                <div style={styles.summarySection}>
                  <div style={styles.summaryTitle}>
                    👨‍⚕️ Doctor Details
                  </div>
                  <div style={styles.summaryRow}>
                    <span style={styles.summaryLabel}>Doctor</span>
                    <span style={styles.summaryValue}>
                      Dr. {bookingData?.doctor?.First || ''} {bookingData?.doctor?.Last || ''}
                    </span>
                  </div>
                  <div style={styles.summaryRow}>
                    <span style={styles.summaryLabel}>Speciality</span>
                    <span style={styles.summaryValue}>{bookingData?.doctor?.Speciality || 'General Physician'}</span>
                  </div>
                  <div style={{...styles.summaryRow, borderBottom: 'none'}}>
                    <span style={styles.summaryLabel}>Clinic</span>
                    <span style={styles.summaryValue}>{bookingData?.doctor?.ClinicName || "Doctor's Clinic"}</span>
                  </div>
                </div>

                <div style={styles.summarySection}>
                  <div style={styles.summaryTitle}>
                    📅 Appointment Details
                  </div>
                  <div style={styles.summaryRow}>
                    <span style={styles.summaryLabel}>Date</span>
                    <span style={styles.summaryValue}>
                      {bookingData?.date ? formatDate(bookingData.date) : ''}
                    </span>
                  </div>
                  <div style={{...styles.summaryRow, borderBottom: 'none'}}>
                    <span style={styles.summaryLabel}>Time</span>
                    <span style={styles.summaryValue}>{selectedSlot}</span>
                  </div>
                </div>

                <div style={styles.summarySection}>
                  <div style={styles.summaryTitle}>
                    👤 Patient Information
                  </div>
                  <div style={styles.summaryRow}>
                    <span style={styles.summaryLabel}>Name</span>
                    <span style={styles.summaryValue}>{patientName}</span>
                  </div>
                  <div style={styles.summaryRow}>
                    <span style={styles.summaryLabel}>Age</span>
                    <span style={styles.summaryValue}>{patientAge} years</span>
                  </div>
                  <div style={styles.summaryRow}>
                    <span style={styles.summaryLabel}>Mobile</span>
                    <span style={styles.summaryValue}>{phoneNumber}</span>
                  </div>
                  <div style={{...styles.summaryRow, borderBottom: 'none'}}>
                    <span style={styles.summaryLabel}>Email</span>
                    <span style={styles.summaryValue}>{email}</span>
                  </div>
                </div>

                {(healthIssues || medicalHistory || currentMedications) && (
                  <div style={{...styles.summarySection, borderBottom: 'none', backgroundColor: '#fff3e0'}}>
                    <div style={styles.summaryTitle}>
                      🏥 Health Information
                    </div>
                    {healthIssues && (
                      <div style={{marginBottom: '12px'}}>
                        <div style={{...styles.summaryLabel, marginBottom: '5px'}}>Current Issues:</div>
                        <div style={{fontSize: '13px', color: '#333', padding: '10px', backgroundColor: 'white', borderRadius: '6px'}}>
                          {healthIssues}
                        </div>
                      </div>
                    )}
                    {medicalHistory && (
                      <div style={{marginBottom: '12px'}}>
                        <div style={{...styles.summaryLabel, marginBottom: '5px'}}>Medical History:</div>
                        <div style={{fontSize: '13px', color: '#333', padding: '10px', backgroundColor: 'white', borderRadius: '6px'}}>
                          {medicalHistory}
                        </div>
                      </div>
                    )}
                    {currentMedications && (
                      <div>
                        <div style={{...styles.summaryLabel, marginBottom: '5px'}}>Current Medications:</div>
                        <div style={{fontSize: '13px', color: '#333', padding: '10px', backgroundColor: 'white', borderRadius: '6px'}}>
                          {currentMedications}
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>

              <Button 
                variant="success"
                style={{...styles.btnSuccess, marginTop: '30px', width: '100%'}}
                onClick={finalizeBooking}
                disabled={loading}
              >
                {loading ? (
                  <>
                    <Spinner animation="border" size="sm" style={{marginRight: '8px'}} />
                    Booking...
                  </>
                ) : (
                  '✅ Confirm & Book Appointment'
                )}
              </Button>
            </div>
          )}
        </Modal.Body>

        <Modal.Footer style={{backgroundColor: 'white', padding: '20px 30px', borderTop: '1px solid #e0e0e0'}}>
          <div className="d-flex justify-content-between w-100">
            <div>
              {step > 1 && step < 4 && (
                <Button 
                  variant="outline-secondary"
                  onClick={() => {
                    if (step === 2 && otpSent) {
                      setOtpSent(false);
                    } else {
                      setStep(step - 1);
                    }
                  }}
                >
                  ← Back
                </Button>
              )}
            </div>
            <Button variant="outline-danger" onClick={handleModalClose}>
              Cancel
            </Button>
          </div>
        </Modal.Footer>
      </div>
    </Modal>
  );
};

export default TimeSlotModal;